/* Tab (Oct 12 2026): keeps the free-shipping bar current after cart changes (add to cart, quantity, remove). The bar itself is Liquid (snippets/tab-free-shipping.liquid); this only refreshes numbers from /cart.js. */
(function(){
  var money=function(cents){ return '$'+(cents/100).toFixed(2); };
  function paint(total){
    document.querySelectorAll('[data-tab-fs]').forEach(function(el){
      var min=parseInt(el.getAttribute('data-min'),10)||3999; var left=min-total; var pct=Math.max(0,Math.min(100,Math.round(total*100/min)));
      el.setAttribute('data-total',total);
      el.classList.toggle('is-done', left<=0); el.classList.toggle('is-empty', total===0);
      var amt=el.querySelector('.tab-fs__amt'); if(amt) amt.textContent=money(Math.max(left,0));
      var fill=el.querySelector('.tab-fs__fill'); if(fill) fill.style.width=pct+'%';
      var bar=el.querySelector('.tab-fs__bar'); if(bar) bar.setAttribute('aria-valuenow',pct);
    });
  }
  var t; function refresh(){ clearTimeout(t); t=setTimeout(function(){
    fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){ if(c && typeof c.total_price==='number') paint(c.total_price); }).catch(function(){});
  },250); }
  ['cart:refresh','line-item:change:end','cart:updated','cart-drawer:open','product:added'].forEach(function(ev){ document.addEventListener(ev, refresh); });
  // Palo Alto fires add-to-cart through fetch; watch the drawer for re-renders too
  function outside(muts){ return muts.some(function(m){ var n=m.target.nodeType===1?m.target:m.target.parentElement; return !(n && n.closest && n.closest('[data-tab-fs]')); }); }
  var drawer=document.getElementById('Cart-Drawer');
  if(drawer && 'MutationObserver' in window){ new MutationObserver(function(muts){ if(outside(muts)) refresh(); }).observe(drawer,{childList:true,subtree:true}); }
  var cart=document.getElementById('Cart');
  if(cart && 'MutationObserver' in window){ new MutationObserver(function(muts){ if(outside(muts)) refresh(); }).observe(cart,{childList:true}); }
})();
